import { Skeleton } from "@/components/ui/skeleton";

/** Skeleton shown while a lazy-loaded calculator panel loads. */
export function CalculatorsPanelSkeleton() {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Loading calculator">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-10 w-full rounded-lg" />
      <Skeleton className="h-10 w-full rounded-lg" />
      <Skeleton className="h-64 w-full rounded-xl" />
    </div>
  );
}

const CALCULATOR_GRID_SKELETON_KEYS = [
  "calc-grid-1",
  "calc-grid-2",
  "calc-grid-3",
  "calc-grid-4",
  "calc-grid-5",
  "calc-grid-6",
  "calc-grid-7",
  "calc-grid-8",
  "calc-grid-9",
] as const;

/** Skeleton for the calculator selection grid on /calculators. */
export function CalculatorsGridSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading calculators">
      <Skeleton className="h-10 w-56" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CALCULATOR_GRID_SKELETON_KEYS.map((skeletonKey) => (
          <Skeleton key={skeletonKey} className="h-28 w-full rounded-xl" />
        ))}
      </div>
    </div>
  );
}
